import moment from 'moment';

const currentDate = new Date();

const initialState = {
    revenue: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
            users: { label: 'Все клиенты', value: 'all' },
        },
        loading: false,
        error: null
    },
    purchase: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
        },
        loading: false,
        error: null
    },
    revenuePromotions: {
        result: null,
        promotions: [],
        filters: {
            points: [],
            promotions: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
        },
        loading: false,
        error: null
    },
    revenuePromocodes: {
        result: null,
        promocodes: [],
        filters: {
            points: [],
            promocodes: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
        },
        loading: false,
        error: null
    },
    salesHours: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
        },
        loading: false,
        error: null
    },
    firstOrders: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
            users: { label: 'Все клиенты', value: 'all' },
        },
        loading: false,
        error: null
    },
    cashback: {
        result: null,
        filters: {
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            cities: [],
            lvls: [],
            type: { label: 'Все типы', value: 'all'},
        },
        loading: false,
        error: null
    },
    deletedUsers: {
        result: null,
        filters: {
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            lvls: [],
            points: [],
            type: { label: 'Все типы', value: 'all'},
        },
        loading: false,
        error: null
    },
    costprice: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
            users: { label: 'Все клиенты', value: 'all' },
        },
        loading: false,
        error: null
    },
    delivery: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            deliveryMethod: 'delivery',
            courierId: 'all',
            status: 'done',
            users: { label: 'Все клиенты', value: 'all' },
        },
        loading: false,
        error: null
    },
    dynamicsPrices: {
        invoices: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            aggDataIsNull: true,
            status: 'done',
            users: { label: 'Все клиенты', value: 'all' },
        },
        loading: false,
        error: null
    },
    salesReport: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
        },
        loading: false,
        error: null
    },
    stagesOrders: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
        },
        loading: false,
        error: null
    },
    abcAnalysis: {
        result: null,
        filters: {
            points: [],
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            status: 'done',
        },
        loading: false,
        error: null
    },
    cashbackNew: {
        result: null,
        filters: {
            created_at_lte: new Date(moment(currentDate).endOf('day')),
            created_at_gte: new Date(moment(currentDate).startOf('day')),
            regionalDirectors: [],
            points: [],
            lvls: [],
            type: { label: 'Все типы', value: 'all'},
        },
        loading: false,
        error: null
    },
    unactiveClients: {
        result: null,
        count: null,
        filters: {
            last_order_lte: new Date(moment(currentDate).subtract(1, 'months').endOf('day')),
            city: null,
        },
        loading: false,
        error: null
    },
    incomeStatement: {
        result: null,
        orders: [],
        workingShifts: [],
        otherExpenditures: [],
        filters: {
            month: new Date(moment(currentDate).subtract(1, 'months').startOf('month')),
            point: null,
            status: 'done',
        },
        loading: false,
        error: null
    },
    consumptionSemi: {
        result: null,
        filters: {
            date_gt: moment(currentDate).subtract({ days: 15 }).toDate(),
            date_lte: currentDate,
            point: null,
            category: null,
            _start: 0,
            _limit: 10,
            _sort: 'id:ASC',
        },
        error: null
    }
};

export default function reports(state = initialState, action) {
  switch(action.type) {
        case 'SET_REPORTS': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    result: action.result
                }
            };
        }
        case 'SET_REPORTS_FILTERS': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    filters: action.filters
                }
            };
        }
        case 'RESET_REPORTS_FILTERS': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    filters: initialState[action.name].filters
                }
            };
        }
        case 'RESET_REPORT': {
            return {
                ...state,
                [action.name]: initialState[action.name]
            };
        }
        case 'SET_REPORTS_LOADER': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    loading: action.loading
                }
            }
        }
        case 'SET_REPORTS_ERROR': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    error: action.error
                }
            }
        }
        case 'SET_REPORTS_FIELD': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    [action.field]: action.data, 
                }
            }
        }
        case 'SET_REPORTS_PAGING': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    paging: action.paging
                }
            }
        }
        case 'SET_REPORTS_INCOME_STATEMENT': {
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    result: action.result,
                    orders: action.orders,
                    workingShifts: action.workingShifts,
                    otherExpenditures: action.otherExpenditures,
                }
            }
        }
        default: return state;
    }
}